import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, isRef as _isRef, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

import { computed } from "vue";
import { StepperProps } from "@/types";
import { useVModel } from "@/hooks";
import { TextButton } from "@/components/common/button";
import { FlexBox } from "@/components/common/display";


/**
 * Displays a generic stepper.
 */
const __default__ = {
  name: "Stepper",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    steps: {},
    denseLabels: { type: Boolean },
    hideActions: { type: Boolean },
    hideStepBack: { type: Boolean },
    color: {},
    minimal: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const currentStep = useVModel(props, "modelValue");

const isStepDone = computed(() => props.steps[props.modelValue - 1].done);
const continueText = computed(() =>
  currentStep.value === props.steps.length ? "Submit" : "Continue"
);

const className = computed(() => {
  let classes = "full-width bg-transparent";

  if (props.denseLabels) {
    classes += " stepper-minimal";
  }

  return classes;
});

/**
 * Moves one step backward.
 */
function onStepBack(): void {
  currentStep.value--;
}

/**
 * Moves one step forward, or submits if on the last step.
 */
function onStepForward(): void {
  if (currentStep.value >= props.steps.length) {
    emit("submit");
  } else {
    currentStep.value++;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_step = _resolveComponent("q-step")!
  const _component_q_stepper_navigation = _resolveComponent("q-stepper-navigation")!
  const _component_q_stepper = _resolveComponent("q-stepper")!

  return (_openBlock(), _createBlock(_component_q_stepper, {
    modelValue: _unref(currentStep),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentStep) ? (currentStep).value = $event : null)),
    flat: "",
    animated: "",
    class: _normalizeClass(className.value),
    "header-nav": ""
  }, _createSlots({
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.steps, (step, idx) => {
        return (_openBlock(), _createBlock(_component_q_step, {
          key: step.title,
          name: idx + 1,
          title: step.title,
          done: step.done,
          caption: step.caption,
          "header-nav": step.done && !props.hideStepBack,
          color: 
        step.done && props.color === 'gradient'
          ? `nodeGradient${idx + 1}`
          : undefined
      
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, idx + 1)
          ]),
          _: 2
        }, 1032, ["name", "title", "done", "caption", "header-nav", "color"]))
      }), 128))
    ]),
    _: 2
  }, [
    (!props.hideActions)
      ? {
          name: "navigation",
          fn: _withCtx(() => [
            _createVNode(_component_q_stepper_navigation, { class: "q-mt-sm" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "actions"),
                _createVNode(_unref(FlexBox), {
                  "full-width": "",
                  align: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TextButton), {
                      color: "primary",
                      outlined: _unref(currentStep) !== _ctx.steps.length,
                      disabled: !isStepDone.value,
                      loading: props.loading,
                      "data-cy": "button-stepper-continue",
                      label: continueText.value,
                      onClick: onStepForward
                    }, null, 8, ["outlined", "disabled", "loading", "label"]),
                    _createVNode(_unref(TextButton), {
                      text: "",
                      color: "primary",
                      disabled: _unref(currentStep) === 1,
                      "data-cy": "button-stepper-back",
                      label: "Back",
                      class: "q-ml-sm",
                      onClick: onStepBack
                    }, null, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 3
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "class"]))
}
}

})